
import { defineComponent } from "vue";

import CardCareer from "~/vue/molecules/cards/CardCareer.vue";
import CardKnowledgeHub from "~/vue/molecules/cards/CardKnowledgeHub.vue";
import CardLocation from "~/vue/molecules/cards/CardLocation.vue";
import CardPrimary from "~/vue/molecules/cards/CardPrimary.vue";
import ConsentVideo from "~/vue/organisms/consents/ConsentVideo.vue";
import SliderLocationCards from "~/vue/organisms/sliders/SliderLocationCards.vue";
import VideoPrimary from "~/vue/atoms/videos/VideoPrimary.vue";
import ViewKnowledgeHub from "~/vue/organisms/views/ViewKnowledgeHub.vue";

export default defineComponent({
	components: {
		"card--career": CardCareer,
		"card--knowledge-hub": CardKnowledgeHub,
		"card--location": CardLocation,
		"card--primary": CardPrimary,
		"consent--video": ConsentVideo,
		"slider--location-cards": SliderLocationCards,
		"video--primary": VideoPrimary,
		"view--knowledge-hub": ViewKnowledgeHub,
	},
});
